<template>
  <div
    v-if="compatibleProducts.length > 0"
    data-test="compatible-products-list-desktop"
  >
    <ul
      :id="LIST_ID_DESKTOP"
      class="overflow-hidden [interpolate-size:allow-keywords] transition-[max-height] duration-300 ease-in-out"
      :class="{
        'max-h-[3.1875rem] [mask-image:linear-gradient(to_bottom,black_10%,transparent_90%)]':
          !isExpanded,
        'supports-[interpolate-size:allow-keywords]:max-h-[max-content] supports-[not(interpolate-size:allow-keywords)]:max-h-[30rem]':
          isExpanded,
      }"
    >
      <li
        v-for="(item, index) in compatibleProducts"
        :key="item"
        class="label-medium inline-block"
      >
        <span>{{ item }}</span>
        <span
          v-if="index < compatibleProducts.length - 1"
          aria-hidden="true"
          class="mx-4"
          >•</span
        >
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { LIST_ID_DESKTOP } from '../../CompatibleWith.constants'

defineProps<{
  compatibleProducts: readonly string[]
  isExpanded: boolean
}>()

defineOptions({
  name: 'CompatibleWithProductsListDesktop',
})
</script>
